import React from 'react';
import { Global, css, keyframes } from '@emotion/core';

import { BODY_OVERFLOW_FOR_MODAL } from 'shared/constants/dom';
import normalize from './normalize';
import InterWoff from './assets/fonts/Inter.woff2';
// import InterRegularWoff from './assets/fonts/Inter-Regular.woff2';
// import InterMediumWoff from './assets/fonts/Inter-Medium.woff2';
// import InterSemiBoldWoff from './assets/fonts/Inter-SemiBold.woff2';

const fadeIn = keyframes`
  from { opacity: 0; }
`;

const fadeOut = keyframes`
  to { opacity: 0; }
`;

const slideFromRight = keyframes`
  from { transform: translateX(300px); }
`;

const slideToLeft = keyframes`
  to { transform: translateX(-300px); }
`;

const slideToRight = keyframes`
  to { transform: translateX(300px); }
`;

const slideFromLeft = keyframes`
  from { transform: translateX(-300px); }
`;

const BaseStyles = () => (
  <Global
    styles={css`
      ${normalize}
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
      }

      ::view-transition-old(root) {
        animation: 300ms cubic-bezier(0.4, 0, 1, 1) both ${fadeOut},
          1000ms cubic-bezier(0.4, 0, 0.2, 1) both ${slideToLeft};
      }

      ::view-transition-new(root) {
        animation: 400ms cubic-bezier(0, 0, 0.2, 1) 300ms both ${fadeIn},
          1000ms cubic-bezier(0.4, 0, 0.2, 1) both ${slideFromRight};
      }

      .back-transition {
        display: inherit;
      }

      @keyframes slideLeft {
        from {
          transform: translateX(100%);
        }
        to {
          transform: translateX(0);
        }
      }
      @keyframes slideInOutAnimation {
        0% {
          top: 100%;
          visibility: visible;
        }
        20% {
          top: 0px;
        }
        35% {
          top: -100%;
          visibility: hidden;
        }
        100% {
          top: 100%;
          visibility: hidden;
        }
      }

      .back-transition::view-transition-old(root) {
        animation-name: fade-out, ${slideToRight};
      }

      .back-transition::view-transition-new(root) {
        animation-name: fade-in, ${slideFromLeft};
      }

      @font-face {
        font-family: 'Inter';
        src: url('${InterWoff}') format('woff2');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'Inter';
        src: url('${InterWoff}') format('woff2');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'Inter';
        src: url('${InterWoff}') format('woff2');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }

      body {
        font-family: 'Inter', Roboto, Arial, sans-serif;
        background-color: #f3f3f3;
        font-size: 14px;

        &.${BODY_OVERFLOW_FOR_MODAL} {
          overflow: hidden;
        }
        line-height: 1;
      }

      :focus {
        outline: 0;
      }
      ol,
      ul {
        list-style: none;
      }
      .grecaptcha-badge {
        visibility: hidden;
      }
    `}
  />
);

export default BaseStyles;
